<template>
  <el-drawer
    :visible.sync="visible"
    @open="init"
    @close="doClose"
    direction="rtl"
    size="960px"
    :withHeader="false">
    <el-card class="box-card" shadow="never" style="border-bottom: none;height: 100vh;overflow-y: scroll">

      <div class="drawer-header">
        <h2 class="title">{{ modelId ? "编辑模型" : "添加模型" }}</h2>
        <div class="toolbar text-align-reverse">
          <el-button size="small" type="primary" @click="save" round><i class="fa fa-save"></i> 保存</el-button>
        </div>
      </div>
      <el-divider class="margin-bottom-15 margin-top-10"></el-divider>
      <el-form :model="model" :show-message="false" label-width="80px" size="small">
        <el-form-item prop="name" label="模型名称:">
          <el-input type="input" v-model="model.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="类型:">
              <el-radio-group v-model="model.type">
                <el-radio :label="0">通用模型</el-radio>
                <el-radio :label="1">公司模型</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="model.type === 1">
            <el-form-item label="代理公司:">
              <el-select v-model="model.companyId" placeholder="请选择公司">
                <el-option
                  v-for="item in companyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12" v-if="model.type !== 1">
            <el-form-item label="行业分类">
              <el-select v-model="model.categoryId" placeholder="请选择分类类型" @change="ChangeCategory">
                <el-option
                  v-for="item in cateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="model.type !== 1">
            <el-form-item label="岗位:">
              <el-select style="width: 80%" v-model="model.postId" placeholder="请选择岗位">
                <el-option
                  v-for="item in posts"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="model.type == 1">
            <el-form-item label="客户公司:">
              <el-select v-model="model.customerId" placeholder="请选择分类类型">
                <el-option
                  v-for="item in customerList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="model.type == 1">
            <el-form-item label="岗位:">
              <el-select style="width: 80%" v-model="model.postId" placeholder="请选择岗位" @change="ChangePost">
                <el-option
                  v-for="item in posts"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="introduce" label="介绍:">
          <el-input type="textarea" v-model="model.introduce" placeholder="请输入介绍"></el-input>
        </el-form-item>
        <el-form-item prop="remark" label="备注:">
          <el-input type="textarea" v-model="model.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-button class="button-new-tag" size="small" @click="toAddModel"><i class="fa fa-plus"></i> 添加维度</el-button>
        <table class="table table-bordered margin-tb-10">
          <tr class="bg-light-cyan">
            <th width="90" v-for="(item,key) in contents" :key="key">{{ item.name }}</th>
          </tr>
          <tr>
            <td valign="middle" v-for="(item,key) in contents" :key="key">
              <el-input type="text" v-model="item.norm" placeholder="输入常模标准值"></el-input>
            </td>
          </tr>
        </table>
      </el-form>

      <degree-save :visible="degreeDialog" :content="contents" @done="handleFinish"></degree-save>
    </el-card>
  </el-drawer>
</template>

<script>
import { get, update, save } from "@/api/rep/model";
import { fetchAll } from "@/api/rep/category";
import { fetchPost, fetchByCategoryId, get as getPost, findByCustomer } from "@/api/rep/post";
import { findAllList } from "@/api/manage/company";
import { fetchList as fetchCustomer } from "@/api/enterprise/customer";
import DegreeSave from "./DegreeSave";

export default {
  components: { DegreeSave },
  props: {
    visible: false,
    modelId: null
  },
  data: function() {
    return {
      model: {
        type: 0
      },
      contents: [],
      degree: "",
      degreeDialog: false,
      posts: [],
      cateList: [],
      customerList: [],
      companyList: []
    };
  },
  watch: {
    "model.type": {
      handler(newType, oldType) {
        this.$set(this.model, "postId", "");
      },
      immediate: true
    },
    "model.companyId": {
      handler(newType, oldType) {
        if (newType != oldType) {
          this.companyList.forEach(o => {
            if (o.id === this.model.companyId) {
              this.model.companyName = o.name;
            }
          });
          this.fetchCustomer(newType);
          this.$set(this.model, "postId", "");
          this.$set(this.model, "customerId", "");
        }
      }
    },
    "model.customerId": {
      handler(newType, oldType) {
        if (newType != oldType && newType != "") {
          this.findPostByCustomer(newType);
          this.$set(this.model, "postId", "");
        }
      }
    },
    "model.postId": {
      handler(newType, oldType) {
        this.posts.forEach(o => {
          if (o.id == this.model.postId) {
            this.model.postName = o.name;
          }
        });
      }
    }
  },
  methods: {
    init() {
      this.getTree();
      this.getPosts();
      this.getCompany();
      if (this.modelId) {
        get(this.modelId).then(resp => {
          this.model = resp.data.result;
          this.contents = this.model.contents;
        });
      } else {
        this.model = { type: 0 };
        this.contents = [];
      }
    },
    findPostByCustomer(customerId) {
      findByCustomer(customerId).then(resp => {
        this.posts = resp.data.result || [];
      });
    },
    getCompany() {
      findAllList().then(res => {
        this.companyList = res.data.result;
      });
    },
    getTree() {
      fetchAll().then(resp => {
        this.cateList = resp.data.result;
      });
    },
    fetchCustomer(companyId) {
      if (companyId) {
        fetchCustomer(companyId, { pageSize: 1000 }).then(resp => {
          this.customerList = resp.data.result.records || [];
        });
      }
    },
    getPosts() {
      fetchPost().then(res => {
        this.posts = res.data.result;
      });
    },
    doClose() {
      this.$emit("done", false);
    },
    toAddModel() {
      this.degreeDialog = true;
    },
    handleFinish(val) {
      this.degreeDialog = false;
      if (val) {
        this.contents = val;
      }
    },
    save() {
      this.model.contents = this.contents;
      if (this.modelId) {
        update(this.model).then(res => {
          this.$message.success("保存成功");
          this.$emit("done", true);
        });
      } else {
        save(this.model).then(res => {
          this.$message.success("保存成功");
          this.$emit("done", true);
        });
      }
    },
    ChangeCategory(val) {
      fetchByCategoryId(val).then(res => {
        this.posts = res.data.result;
      });
    },
    ChangePost(val) {
      getPost(val).then(res => {
        this.model.categoryId = res.data.result.categoryId;
        console.info(this.model);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.option-table {
  margin: 5px auto;
  border-left: none;
  border-right: none;

  th {
    background-color: #f7f7f7;
  }

  td {
    padding: 5px 8px !important;
    vertical-align: middle;
  }
}

.norm-setting-page {
  .el-form-item {
    margin: 0 !important;
  }

  .el-select.el-select--small {
    ::v-deep .el-input__inner {
      border-radius: 2px;
      padding-left: 5px;
    }
  }

  .el-input.el-input--small {
    ::v-deep .el-input__inner {
      border-radius: 2px;
      padding-left: 5px;
    }
  }

  .el-input-number--small {
    width: 70px;

    ::v-deep .el-input--small .el-input__inner {
      padding-left: 5px !important;
      padding-right: 40px;
      border-radius: 2px;
    }
  }
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.no-data {
  text-align: center;
  padding: 50px 0;

  &::before {
    content: ' ';
    display: block;
    min-height: 180px;
    background: url("~@images/nodata1.png") center 0 no-repeat;
    background-size: contain;
  }
}
</style>
